var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"link",staticClass:"link",style:({
    opacity : _vm.skip ? 0 : 1,
}),attrs:{"href":_vm.link,"target":"_blank"}},[_c('img',{ref:"img",style:({
      opacity: _vm.image ? 1 : 0,
      animationDelay: Math.random() + 's',
    }),attrs:{"src":_vm.image}}),_c('span',{ref:"span"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }